import { useState, useEffect, useRef } from "react";
import { gsap } from "gsap";
import { motion } from "framer-motion";
import './Circle.css';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
const Circle = ({ bgColor, left = 'none', top = 'none', width, height, right = 'none', bottom = 'none', borderWidth = '50px', icon, phrase }) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isHovered, setIsHovered] = useState(false);
    const circleRef = useRef(null);
    const cursor = useRef(null);
    let posX = 0;
    let posY = 0;
    let mouseX = 0;
    let mouseY = 0;
    let tl = useRef(gsap.timeline({ paused: true }));

    useEffect(() => {
        const handleMouseMove = (e) => {
            const rect = circleRef.current.getBoundingClientRect();
            mouseX = e.clientX - rect.left;
            mouseY = e.clientY - rect.top;
        };

        if (isHovered) {
            tl.current = gsap.timeline({
                repeat: -1,
                onRepeat: function () {
                    posX += (mouseX - posX) / 10;
                    posY += (mouseY - posY) / 10;
                    tl.current.set(cursor.current, {
                        css: {
                            left: posX - 50,
                            top: posY - 50
                        }
                    });
                }
            });
            circleRef.current.addEventListener('mousemove', handleMouseMove);
            tl.current.play();
        } else {
            if (tl.current) {
                tl.current.kill();
            }
            if (circleRef.current) {
                circleRef.current.removeEventListener('mousemove', handleMouseMove);
            }
        }

        return () => {
            if (tl.current) {
                tl.current.kill();
            }
            if (circleRef.current) {
                circleRef.current.removeEventListener('mousemove', handleMouseMove);
            }
        };
    }, [isHovered]);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    let customWidth = windowWidth > 768 ? width : `${parseInt(width) / 1.2}px`;
    let customHeight = windowWidth > 768 ? height : `${parseInt(height) / 1.2}px`;
    const customLeft = windowWidth > 768 ? left : `${parseInt(left) - 70}px`;
    const customBorder = windowWidth > 420 ? borderWidth : `${0}px`;
    let customDisplay = 'block';

    if (customLeft === 'NaNpx') {
        customDisplay = 'none';
    }

    return (
        <motion.div
            ref={circleRef}
            initial={{ opacity: 0.5 }}
            whileHover={{ scale: 1.2, opacity: 1 }}
            whileTap={{ scale: 1.2, opacity: 1 }}
            style={{
                borderRadius: "50%",
                width: customWidth,
                height: customHeight,
                backgroundColor: bgColor,
                position: "absolute",
                left: customLeft,
                top: top,
                right: right,
                bottom: bottom,
                display: customDisplay,
                boxSizing: "content-box"
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div style={{ position: "relative" }}>
                <div
                    className={`cursor-follow ${isHovered ? 'visible' : ''}`}
                    ref={cursor}
                >
                    {icon}
                    <p>{phrase}</p>
                </div>
            </div>
        </motion.div>
    );
};

const Circles = () => {
    return (
        <div style={{ position: "relative", maxWidth: '648px', width: '100%', height: '900px', boxSizing: "content-box" }}>
            <Circle bgColor="#40b26b" left="90px" top="100px" width="80px" height="80px" imageSrc={require("../../assets/animation/1.jpg")} icon={<ChatOutlinedIcon style={{ fontSize: '150px' }} />} phrase="Lorem Ipsum text" />
            <Circle bgColor="#F9C518" left="calc(100% - 250px)" top="50px" width="200px" height="200px" icon={<ChatOutlinedIcon style={{ fontSize: '150px' }} />} phrase="Lorem Ipsum text" />
            <Circle bgColor="#F8922B" left="100px" top="280px" width="100px" height="100px" icon={<ChatOutlinedIcon style={{ fontSize: '150px' }} />} phrase="Lorem Ipsum text" />
            <Circle bgColor="black" left="calc(100% - 190px)" top="320px" width="50px" height="50px" borderWidth="20px" icon={<ChatOutlinedIcon style={{ fontSize: '150px' }} />} phrase="Lorem Ipsum text" />
            <Circle bgColor="grey" left="calc(100% - 80px)" top="350px" width="30px" height="30px" borderWidth="30px" icon={<ChatOutlinedIcon style={{ fontSize: '150px' }} />} phrase="Lorem Ipsum text" />
            <Circle bgColor="#CD5CE7" left="40px" top="450px" width="80px" height="80px" borderWidth="30px" icon={<ChatOutlinedIcon style={{ fontSize: '150px' }} />} phrase="Lorem Ipsum text" />
            <Circle bgColor="#3AB8D1" left="200px" top="420px" width="200px" height="200px" borderWidth="30px" icon={<ChatOutlinedIcon style={{ fontSize: '150px' }} />} phrase="Lorem Ipsum text" />
            <Circle bgColor="#5D7CF9" left="calc(100% - 150px)" top="500px" width="100px" height="100px" borderWidth="20px" icon={<ChatOutlinedIcon style={{ fontSize: '150px' }} />} phrase="Lorem Ipsum text" />
            <Circle bgColor="#F26497" left="calc(100% - 220px)" top="650px" width="70px" height="70px" borderWidth="30px" icon={<ChatOutlinedIcon style={{ fontSize: '150px' }} />} phrase="Lorem Ipsum text" />
            <Circle bgColor="#94D82D" left="1.0px" top="700px" width="200px" height="200px" borderWidth="20px" icon={<ChatOutlinedIcon style={{ fontSize: '150px' }} />} phrase="Lorem Ipsum text" />
            <Circle bgColor="#4AA9FD" left="calc(100% - 100px)" top="750px" width="50px" height="50px" borderWidth="20px" icon={<ChatOutlinedIcon style={{ fontSize: '150px' }} />} phrase="Lorem Ipsum text" />
        </div>
    );
};

export default Circles;
